import * as XLSX from 'xlsx';

// Excel de ejemplo para importar participantes. Las cabeceras tienen que llamarse
// exactamente "Email" y "Telefono" (sin tilde): es lo que leen los formularios de crear.
export const downloadParticipantsTemplate = (t) => {
  const rows = [
    ['Email', 'Telefono'],
    [t('participants_template_example_email1'), '600000001'],
    [t('participants_template_example_email2'), '600000002'],
  ];
  const sheet = XLSX.utils.aoa_to_sheet(rows);
  sheet['!cols'] = [{ wch: 34 }, { wch: 16 }];

  const help = XLSX.utils.aoa_to_sheet([
    [t('participants_template_help_title')],
    [t('participants_template_help_1')],
    [t('participants_template_help_2')],
    [t('participants_template_help_3')],
    [t('participants_template_help_4')],
  ]);
  help['!cols'] = [{ wch: 90 }];

  const book = XLSX.utils.book_new();
  // La hoja de participantes va primera: es la unica que se lee al importar
  XLSX.utils.book_append_sheet(book, sheet, t('participants_template_sheet'));
  XLSX.utils.book_append_sheet(book, help, t('participants_template_help_sheet'));
  XLSX.writeFile(book, `${t('participants_template_filename')}.xlsx`);
};

export default downloadParticipantsTemplate;
